import BundleZone from './bundleZone';

let showMoreBtn = false;
let showMoreBtnClicked = false;
let showMoreBundleRes = [];
let showMoreBundleZones = {};

export function findZonesInDomNode(DomNode = document) {
	return DomNode.querySelectorAll('[data-related-bundle-zone]');
}

export function buildZoneList(bundleElements) {
	const bundleZones = {};
	const bundleIds = [];
	for (let i = 0; i < bundleElements.length; i++) {
		const bundleElement = bundleElements[i];
		const newBundle = new BundleZone(bundleElement);
		bundleZones[newBundle.placmentId] = newBundle;
		bundleIds.push(newBundle.placmentId);
	}

	return {
		bundleZones,
		bundleIds,
	};
}

export function renderBundles(bundleZones, bundleResults) {
	const bundleRenderRequests = [];
	if (showMoreBtnClicked) {
		let counter = 0;
		bundleResults.forEach(bundleRes => {
			if (bundleZones[bundleRes.zoneId] && counter < 2) {
				counter += 1;
				bundleZones[bundleRes.zoneId].addResults(bundleRes);
				bundleRenderRequests.push(
					bundleZones[bundleRes.zoneId].requestRender(),
				);
			}
		});
	} else if (Object.keys(bundleResults).length > 0) {
		showMoreBundleRes = [...bundleResults];
		showMoreBundleZones = { ...bundleZones };
		const bundleRes = bundleResults[0];
		if (bundleRes) {
			if (bundleZones[bundleRes.zoneId]) {
				bundleZones[bundleRes.zoneId].addResults(bundleRes);
				bundleRenderRequests.push(
					bundleZones[bundleRes.zoneId].requestRender(),
				);
			}
		}
		showMoreBundleRes.shift();
	}
	return Promise.all(bundleRenderRequests);
}

export function showMoreButton(bundleResults) {
	const showMore = 'show-more-button';
	const bundleZone = document.getElementById('bundleZone');
	showMoreBtn = document.getElementById(showMore);
	if (bundleResults > 0) {
		showMoreBtn.classList.remove('d-none');
	}
	if (showMoreBtn) {
		showMoreBtn.addEventListener('click', e => {
			e.preventDefault();
			showMoreBtnClicked = true;
			showMoreBtn.classList.add('d-none');
			bundleZone.classList.add('show-more-bundles');
			renderBundles(showMoreBundleZones, showMoreBundleRes);
		});
	}
}
